module.exports = __webpack_public_path__ + "img/other_pic04.66c8a296.png";